const state = {
  pkg: {
    id: 0,
    name: '',
    price: '',
    additional_price: '',
    started_at: new Date(),
    expired_at: new Date(),
    created_at: new Date(),
    updated_at: new Date(),
  },
  packages: [],
  units: [],
  quotas: [],
  roles: [],
};

export default state;
